// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import ITypeDef from "./ITypeDef";

export default interface ITypeDefCatalog {
  typeDefs: ITypeDef[];
}
